import { z } from '@harvestiq/zod';

export const submitAipPdfReqSchema = z.object({
  coverageId: z.string().uuid(),
});
export type SubmitAipPdfReq = z.infer<typeof submitAipPdfReqSchema>;

export const submitAipPdfResSchema = z.object({
  errors: z
    .array(
      z.object({
        message: z.string(),
      })
    )
    .optional(),
});
export type SubmitAipPdfRes = z.infer<typeof submitAipPdfResSchema>;
